//@flow
import * as React from 'react'
import { Field } from 'redux-form';
import renderCheckbox from '../../../components/MaterialUi/renderCheckbox';
import styles from './styles'
import type { ContainerRowReduxField$Props } from '../flowTypes'

const ContainerRowReduxCheckboxField=(props:ContainerRowReduxField$Props)=>{
    return (
        <div className="row">
            <div className='col-sm'>
                <Field
                    name={props.field}
                    component={renderCheckbox}
                    label={props.label}
                    style={styles.textFieldStyle}
                />
            </div>
        </div> 
    )
}

export default ContainerRowReduxCheckboxField


// WEBPACK FOOTER //
// ./src/views/ProjectDemeter/common/ContainerRowReduxCheckboxField.js